import { GameSizeConfig } from '@/components/GameItem';
import { PerChunk } from '@/components/GamesGrid/helpers';

import { GameItemSize } from '@/components/GameItem/styled';
import { GridOptions } from '@/components/GamesGrid/styled';

export const gridOptions: GridOptions = {
  columns: 6,
  columnsTablet: 4,
  columnsMobile: 3,
  columnsMobileS: 2,
  columnGap: 16,
  rowGap: 32,
};

export const perChunk: PerChunk = {
  desktopL: 12,
  desktop: 12,
  tablet: 8,
  mobile: 6,
  mobileS: 6,
};

export const gameSizesConfig: GameSizeConfig = {
  desktopL: GameItemSize.M,
  desktop: GameItemSize.S,
  tablet: GameItemSize.M,
  mobile: GameItemSize.S,
  mobileS: GameItemSize.S,
};
